var ostbv = ostbv || {};

ostbv.slider = new function () {
  var self = this;

  this.testimonialSlider = function (selector) {
    selector.owlCarousel({
        responsive:{
            0:{
                items:1
            }
        },
        autoplay: true,
        autoplayTimeout: 11500,
        video: true,
        center: true,
        singleItem: true,
        autoHeight: false,
        lazyLoad: true,
        loop: true,
        nav: false,
        dots: true
    });
}
};